// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"f95fdd47","498":"d90a4478","703":"7d85fe5e","787":"a5cad257"}[chunkId] + ".chunk.js";
};